


















































import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/swiper-bundle.css";
import globals from "@/general/store/modules/globals";
import commons from "@/common/store/modules/commons";

import {
  Swiper as SwiperClass,
  Pagination,
  Mousewheel,
  Autoplay,
  SwiperOptions
} from "swiper";
import { Prop, Vue, Component, Ref } from "vue-property-decorator";

// Swiper modules
SwiperClass.use([Pagination, Mousewheel, Autoplay]);

@Component({
  components: {
    Swiper,
    SwiperSlide
  }
})
export default class TheA01Carousel extends Vue {
  @Prop({
    type: Array,
    required: false
  })
  carouselItems!: any;

  swiperOption = {
    loop: true,
    autoplay: {
      delay: 5000
    },
    speed: 1000,
    centeredSlides: true,
    pagination: {
      el: ".p-the-a01-carousel__carousel__pagination",
      clickable: true
    },
    breakpoints: {
      769: {
        loopFillGroupWithBlank: true,
        slidesPerView: 1.3
      }
    }
  };

  get isSp(): boolean {
    return globals.isLargeBreakpointWidthOfSp;
  }

  get headerHeight(): number {
    // ランク利用表示フラグを見てヘッダーの高さを変える
    if(commons.userInfo.rankDisplayEnabled === true) {
      return 135;
    }
    return 105;
  }
  get addMarginTop(): any {
    const style = {
      marginTop: this.headerHeight.toString() + "px"
    };
    return this.isSp ? style : "";
  }
  get useCarousel() {
    return this.carouselItems.length > 1;
  }

  setUrl(bannerType: number, url: any, categories: any, premiums: any) {
    if (bannerType == 1) {
      return "/product-list/?product-category=" + categories.join();
    } else if (bannerType == 2) {
      if (premiums.length > 1) {
        return "/product-list/?premiums=" + premiums.join();
      } else {
        return "/product-details/?id=" + premiums[0];
      }
    } else {
      return url;
    }
  }
}
